// import addMonths from 'date-fns/addMonths'
import { Data, GraphPayload } from '../types'
import { dateToRussianTimezone } from './areDatesEqual'
import { useMemo } from 'react'

export const formatGraphData: (
  dataKey: string,
  minLength?: number,
  data?: GraphPayload,
  formatFunction?: (value: string) => string | number
) => Data[] = (dataKey, minLength, data, formatFunction = value => value) => {
  const formattedData = data?.map(({ date, value }) => ({
    date: dateToRussianTimezone(new Date(date), true),
    [dataKey]: formatFunction(value)
  })) as Data[]

  return formattedData

  // return !!formattedData && minLength && formattedData.length < minLength
  //   ? ([
  //       ...formattedData,
  //       ...Array(minLength - formattedData?.length)
  //         .fill(0)
  //         .map((el, index) => ({
  //           date: addMonths(formattedData?.[formattedData.length - 1].date, index + 1)
  //         }))
  //     ] as Data[])
  //   : formattedData
}

// TODO: отрефакторить это все при переезде на next
export const getMonthlyInterval = (limit: number, data?: GraphPayload) => {
  if (data && data.length > limit) {
    return Math.floor(data.length / limit)
  }
  return 0
}
